export default __webpack_public_path__ + "static/media/google-play.74c72bb0.svg";